var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _circle, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 437.55115,
    height: 512.62854,
    viewBox: "0 0 437.55115 512.62854",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a4cc79cd-ea29-44e8-8b1f-c84c9f36b99b",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "b528ca4c-b6e8-4382-8c63-b3f7a5882e55",
    "data-name": "Ellipse 108",
    cx: 103.19117,
    cy: 179.22455,
    r: 30,
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "f2334603-0630-41b1-8883-db91ebd0df1d",
    "data-name": "Ellipse 109",
    cx: 105.71115,
    cy: 184.72055,
    r: 24.561,
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a98f854d-ddd1-49f9-826e-9b3b51c42b30-452",
    "data-name": "Path 704",
    d: "M580.47357,453.11426a10.51855,10.51855,0,0,0-1.072,1.264l-49.562-1.751-5.669-10.631-17.162,6.458,8.206,19.8a8,8,0,0,0,8.263,4.889l56.085-6.158a10.50026,10.50026,0,1,0,.911-13.866Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f257447d-301d-44a2-8e09-7759e64535dc-453",
    "data-name": "Path 705",
    d: "M500.40658,458.01428a4.81194,4.81194,0,0,1-2.643-3.017l-6.9-23.169a13.37727,13.37727,0,1,1,24.208-11.392h0l13.372,20.235a4.8171,4.8171,0,0,1-1.981,7.02l-22.04105,10.289a4.811,4.811,0,0,1-4.011.03Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "becfa795-45e6-4313-bdd8-8732b5eb4129-454",
    "data-name": "Path 706",
    d: "M549.22159,693.24127l10.768-5.862-17.485-44.322-15.892,8.651Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e8c8979c-fc56-471c-a205-c14c5d72c2f7-455",
    "data-name": "Path 707",
    d: "M544.56158,691.22028l21.205-11.544h0a15.386,15.386,0,0,1,20.86969,6.15747l.0003.00055.239.439-34.72,18.9Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab11d9ef-02df-4748-a171-c660a3aec0b0-456",
    "data-name": "Path 708",
    d: "M430.73458,693.28925h12.259l5.833-47.288h-18.1Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af78ce6e-a300-42ae-85b6-279af7ebed37-457",
    "data-name": "Path 709",
    d: "M427.60656,689.28729h24.145a15.386,15.386,0,0,1,15.386,15.386v.501h-39.53Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b8635a3a-781b-4583-ae1f-43c79305ccfd-458",
    "data-name": "Path 710",
    d: "M506.91558,483.41425l4,48,44.619,133.856a4,4,0,0,1-2.52991,5.05957q-.16684.05566-.3381.09644l-13.675,3.256a4,4,0,0,1-4.5-2.091l-57.043-113.157a2,2,0,0,0-3.739.471l-25.1,114.362a4,4,0,0,1-3.907,3.142h-12.726a3.993,3.993,0,0,1-4.00046-3.98553q0-.03424.00046-.06848c1.166-79.3-2.68-169.653,27.936-183.946l5-13Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e573b899-9021-4f9b-8786-b9ea4c0ab316-459",
    "data-name": "Path 711",
    d: "M459.47558,478.81427l-5.154-31.177a30.877,30.877,0,0,1,9.769-28.006,30.36108,30.36108,0,0,1,28.331-6.925c.292.078.585.159.878.241a30.783,30.783,0,0,1,22.222,27.346c.984,13.54.1,33.184-9.678,49.87l-.19.324Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf1af282-84f0-4284-9d03-260240daa088-460",
    "data-name": "Path 712",
    d: "M511.36859,365.35226a33.39994,33.39994,0,0,1-19.091,5.9,20.47,20.47,0,0,0,8.114,3.338,67.35852,67.35852,0,0,1-27.514.155,17.807,17.807,0,0,1-5.76-1.978,7.2889,7.2889,0,0,1-3.555-4.755c-.6-3.449,2.083-6.582,4.876-8.693a35.967,35.967,0,0,1,30.224-6.04c3.376.873,6.758,2.347,8.951,5.059s2.843,6.892.753,9.684Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bd051e82-93fb-484c-bc2c-a05379150ad3-461",
    "data-name": "Path 713",
    d: "M484.02157,342.76227c2.847-11.5-7.357-24.268-19.2-24.029-12.013.243-20.854,11.1-26.931,21.464s-12.115,22.117-23.269,26.58a24.029,24.029,0,0,1-32.946-22.894c-1.5,12.593.577,26.219,8.7,35.96s23.233,14.13,34.1,7.584c6.2-3.739,10.169-10.237,13.438-16.7s6.178-13.279,11.131-18.564,12.612-8.792,19.506-6.569c2.736.883,5.191,2.6,8.018,3.126s6.386-.82,6.772-3.669Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a038711e-9241-43ca-acb8-65ac7fef7c62-462",
    "data-name": "Path 714",
    d: "M424.82159,551.20526a10.743,10.743,0,0,1,2.743-16.243l21.305-95.5,21.613,8.871-27.737,91.081a10.8,10.8,0,0,1-17.924,11.791Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a8e2c108-97db-4287-b949-04189b24fe3b-463",
    "data-name": "Path 715",
    d: "M440.43057,453.16425a4.812,4.812,0,0,1-.336-4l8.193-22.745a13.37759,13.37759,0,0,1,26.245,5.2h0l-1.245,24.222a4.81686,4.81686,0,0,1-5.76,4.475l-23.85-4.8a4.812,4.812,0,0,1-3.246-2.357Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#ccc"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "a8ec7779-81bc-4fb5-bea3-5b8fa1590d68",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a61284fa-5c43-4b2c-a220-e074c1426ed7-464",
    "data-name": "Path 410",
    d: "M681.50659,197.34473a5.982,5.982,0,0,0-5.468-3.659H566.8776a5.92,5.92,0,0,0-5.917,5.917v138.095a5.92,5.92,0,0,0,5.917,5.917h109.161a5.925,5.925,0,0,0,5.917-5.917v-138.093A5.80986,5.80986,0,0,0,681.50659,197.34473Zm-.865,140.352a4.609,4.609,0,0,1-4.6,4.6H566.8776a4.6,4.6,0,0,1-4.6-4.6h0v-138.092a4.609,4.609,0,0,1,4.6-4.6h109.161a4.62606,4.62606,0,0,1,4.273,2.9,5.11465,5.11465,0,0,1,.173.519,4.55869,4.55869,0,0,1,.158,1.188Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f058fc04-be1a-4760-b4ca-1d7d0096a0b4-465",
    "data-name": "Path 411",
    d: "M658.7236,226.29175h-32.88a2.6305,2.6305,0,0,1,0-5.261h32.879a2.631,2.631,0,0,1,0,5.261Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b7b03d80-c54f-4ac7-a733-77e3791388e5-466",
    "data-name": "Path 412",
    d: "M658.7236,240.10175h-32.88a2.6305,2.6305,0,0,1,0-5.261h32.879a2.631,2.631,0,0,1,0,5.261Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bbd645bb-3528-4838-b3c9-db478370a388-467",
    "data-name": "Path 413",
    d: "M608.97759,247.96475h-24.033a2.962,2.962,0,0,1-2.959-2.959v-28.355a2.962,2.962,0,0,1,2.959-2.959h24.033a2.963,2.963,0,0,1,2.959,2.959v28.355A2.962,2.962,0,0,1,608.97759,247.96475Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a70c21c1-6213-4b7f-bc14-591f551ac782-468",
    "data-name": "Path 414",
    d: "M658.4946,268.37775h-74.307a2.6305,2.6305,0,0,1,0-5.261h74.307a2.63049,2.63049,0,0,1,0,5.261Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af88612c-f069-4016-a622-4620c9d6e9ee-469",
    "data-name": "Path 415",
    d: "M658.4946,282.19174h-74.307a2.63049,2.63049,0,0,1,0-5.261h74.307a2.63049,2.63049,0,1,1,0,5.261Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b4028583-530b-4323-a807-42e8359c25be-470",
    "data-name": "Path 416",
    d: "M658.4946,295.99673h-74.307a2.63049,2.63049,0,0,1,0-5.261h74.307a2.63049,2.63049,0,0,1,0,5.261Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eea2a91b-a87e-450d-ac84-b33fc6ad943a-471",
    "data-name": "Path 417",
    d: "M658.4946,309.80975h-74.307a2.63049,2.63049,0,0,1,0-5.261h74.307a2.63049,2.63049,0,0,1,0,5.261Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f69f5fd9-c3c3-49bc-9ead-71d5a754157a-472",
    "data-name": "Path 418",
    d: "M658.4946,323.61575h-74.307a2.63049,2.63049,0,0,1,0-5.261h74.307a2.63049,2.63049,0,0,1,0,5.261Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#ccc"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b052e332-5d61-4357-af09-a12de450e4ae-473",
    "data-name": "Path 336",
    d: "M747.43456,278.88326a7.6,7.6,0,0,0-6.95-4.65h-138.725a7.524,7.524,0,0,0-7.52,7.52v175.5a7.524,7.524,0,0,0,7.52,7.52h138.73a7.53,7.53,0,0,0,7.52-7.52v-175.5a7.38544,7.38544,0,0,0-.57-2.87Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M736.13867,454.91992H606.49414c-1.86816-.00195-3.33105-2.0459-3.33105-4.65283V287.46729c.00195-2.60938,1.46582-4.65284,3.33105-4.65284H736.13867c1.86914.00244,3.332,2.0459,3.332,4.65284v162.7998C739.46875,452.876,738.00488,454.91992,736.13867,454.91992Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "a0e2f6aa-04b8-4ab3-a7b0-0f19b8b6a28a-474",
    "data-name": "Path 336",
    d: "M747.43456,278.88326a7.6,7.6,0,0,0-6.95-4.65h-138.725a7.524,7.524,0,0,0-7.52,7.52v175.5a7.524,7.524,0,0,0,7.52,7.52h138.73a7.53,7.53,0,0,0,7.52-7.52v-175.5a7.38544,7.38544,0,0,0-.57-2.87Zm-1.1,178.37a5.857,5.857,0,0,1-5.85,5.85h-138.725a5.851,5.851,0,0,1-5.85-5.848V281.75426a5.858,5.858,0,0,1,5.85-5.85h138.73a5.879,5.879,0,0,1,5.43,3.68,6.48151,6.48151,0,0,1,.22.66,5.80007,5.80007,0,0,1,.2,1.51Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "f7f5684e-e384-4873-9fc1-6b481c0c3185-475",
    "data-name": "Path 337",
    d: "M718.48455,315.66827h-41.786a3.343,3.343,0,0,1,0-6.686h41.786a3.343,3.343,0,1,1,0,6.686Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "a0d63c63-f814-470b-a777-b0a1c00c2ac9-476",
    "data-name": "Path 338",
    d: "M718.48455,333.21828h-41.786a3.343,3.343,0,0,1,0-6.686h41.786a3.343,3.343,0,1,1,0,6.686Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "ff5e0da0-ae1b-43c5-a91c-4cd72feaad08-477",
    "data-name": "Path 339",
    d: "M655.25856,343.21127h-30.537a3.765,3.765,0,0,1-3.761-3.761v-36.036a3.765,3.765,0,0,1,3.761-3.761h30.537a3.765,3.765,0,0,1,3.761,3.761v36.036A3.765,3.765,0,0,1,655.25856,343.21127Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#00bfa6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "ad4ed544-ba1f-4890-b966-6cbda7ed2ca0-478",
    "data-name": "Path 340",
    d: "M718.19457,369.15426h-94.436a3.343,3.343,0,0,1,0-6.686h94.436a3.343,3.343,0,1,1,0,6.686Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "bb4cdd45-0f85-4a7a-88d0-4f1a9d7bd917-479",
    "data-name": "Path 341",
    d: "M718.19457,386.70425h-94.436a3.343,3.343,0,0,1-.01855-6.686h94.45456a3.343,3.343,0,0,1,0,6.686Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "a6089264-0f27-4995-b04f-a5be86198b98-480",
    "data-name": "Path 342",
    d: "M718.19457,404.2543h-94.436a3.343,3.343,0,0,1,0-6.686h94.436a3.343,3.343,0,1,1,.01855,6.686Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#e6e6e6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "a4f00200-1086-48db-adf1-de08956240d5-481",
    "data-name": "Path 343",
    d: "M718.19457,421.80428h-94.436a3.343,3.343,0,1,1-.01855-6.686h94.45456a3.343,3.343,0,0,1,0,6.686Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#e6e6e6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "b49f179d-0424-4766-955e-eb78e4d9d5b3-482",
    "data-name": "Path 344",
    d: "M718.19457,439.35427h-94.436a3.343,3.343,0,1,1-.01855-6.686h94.45456a3.343,3.343,0,0,1,0,6.686Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "ba183dc1-a597-4106-bea7-eb7523e98551",
    "data-name": "Ellipse 44",
    cx: 383.55115,
    cy: 67.62854,
    r: 54,
    fill: "#00bfa6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "a4d5b786-8a25-41ee-bd38-08ceac89f4c5-483",
    "data-name": "Path 692",
    d: "M773.28057,263.10526v-29.791h-15.342v29.791h-7.163l7.416,12.845,7.418,12.847,7.418-12.847,7.417-12.847Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "fb232c29-52fe-45d7-b1d2-fa271477c305-484",
    "data-name": "Path 717",
    d: "M784.8496,706.31427h-381a1,1,0,1,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#e6e6e6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "b543f4e5-af9f-4f22-96b3-c92f4b8b4cba-485",
    "data-name": "Path 694",
    d: "M752.29859,697.42127c-9.6,6.915-22.039,7.262-34.063,6.413-1.679-.118-3.346-.257-5-.407h-.033c-.079-.008-.159-.015-.235-.02l-1.02-.1.08.152.25.472c-.09-.158-.18-.313-.27-.471-.026-.047-.056-.095-.082-.142-3.115-5.421-6.2-11.04-6.992-17.23-.815-6.425,1.475-13.7,7.129-16.857a11.40586,11.40586,0,0,1,2.341-.981q.507-.15,1.028-.26a12.23,12.23,0,0,1,14.223,15.9c4.794-4.916,3.9-12.89,2.246-19.555s-3.663-14.081-.293-20.067a13.23294,13.23294,0,0,1,8.865-6.232c.113-.024.227-.049.34-.07a17.8481,17.8481,0,0,1,12.823,2.247c7.069,4.455,10.7,12.9,11.878,21.174C767.41359,674.70026,763.21158,689.56025,752.29859,697.42127Z",
    transform: "translate(-381.22442 -193.68573)",
    fill: "#f2f2f2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawDownload);
export default __webpack_public_path__ + "static/media/undraw_download.942e969faf3ae21896c1f3d62306bad2.svg";
export { ForwardRef as ReactComponent };